import _jsx from '@babel/runtime/helpers/jsx';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { useId } from '@andes/context';
const namespace = 'andes-carousel-free';
const slideNamespace = "".concat(namespace, "__slide");
const CarouselFree = /*#__PURE__*/function () {
  const CarouselFree = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      'aria-label': ariaLabel,
      children,
      className,
      id,
      innerRef,
      spacing = 12,
      srLabel
    } = _ref;
    const componentId = useId(id);
    return /*#__PURE__*/React.createElement("div", {
      className: namespace,
      ref: ref || innerRef,
      id: componentId
    }, /*#__PURE__*/_jsx("ul", {
      "aria-label": srLabel || ariaLabel,
      className: classNames("".concat(namespace, "__list"), "".concat(namespace, "__list--spacing-").concat(spacing), className)
    }, void 0, children));
  });
  CarouselFree.displayName = 'CarouselFree';
  return CarouselFree;
}();
var CarouselFree$1 = CarouselFree;
const CarouselFreeSlide = /*#__PURE__*/function () {
  const CarouselFreeSlide = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      children,
      className,
      component: Component = 'li'
    } = _ref;
    return /*#__PURE__*/React.createElement(Component, {
      className: classNames("".concat(slideNamespace), className),
      ref: ref
    }, children);
  });
  CarouselFreeSlide.displayName = 'CarouselFreeSlide';
  return CarouselFreeSlide;
}();
var CarouselFreeSlide$1 = CarouselFreeSlide;
export { CarouselFree$1 as CarouselFree, CarouselFreeSlide$1 as CarouselFreeSlide, CarouselFree$1 as default };
